export const dispatchNewEvent = (event, detail = null) => {
  const triggerEvent = new window.CustomEvent(event, { detail });
  return document.body.dispatchEvent(triggerEvent);
};
